import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import SoftAccountStatusPage from './SoftAccountStatusPage';

const _mapStateToProps = (state) => ({
    email: state.authentication.email,
});

export default withRouter(connect(_mapStateToProps)(SoftAccountStatusPage));
